import * as types from '../constants/ActionTypes';

const initialState = {
  layer: 1,
  subTopics: [],
  topics: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SELECT_TOPIC:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}
